module.exports = __webpack_public_path__ + "static/img/poma_img1.9a2a4fea.jpg";